import AjaxRequest from './AjaxRequestWithRetry';
import { ToastrNotificationFactory } from '../../notification/ToastrNotificationFactory';
import LocalStorage from '../../localStorage/access';
import * as config from "../../../constants/config";
import AjaxBlobRequest from './AjaxBlobRequest';

const notificationFactory = new ToastrNotificationFactory();
const tokenUrl = config.apiUrl + "RefreshToken";

function validateOptions(ajaxRequestOptions) {
    if (!ajaxRequestOptions)
        throw new Error('Request options are required to configure the http request.');
}
// API bridge
export function sendRequest(ajaxRequestOptions) {
    validateOptions(ajaxRequestOptions);

    return AjaxRequest(LocalStorage, notificationFactory, config.apiMaxRetryCount, tokenUrl)
    .send(ajaxRequestOptions);
}

export function downloadBlob(ajaxRequestOptions) {
    validateOptions(ajaxRequestOptions);

    return AjaxBlobRequest(LocalStorage, notificationFactory, config.apiMaxRetryCount, tokenUrl).send(ajaxRequestOptions);
}

function mockApiCall(message, resolveResult = undefined) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (resolveResult) {
                if (message) {
                    notificationFactory.createSuccess(message).notify();
                }
                resolve(resolveResult);
            }
            else {
                const errorResult = message ? message : {status: 500};
                notificationFactory.createError(errorResult).notify();
                reject(errorResult);
            }

        }, config.environment.DELAY);
    });
}

export function mockResolveApiCall(result, successMessage) {
    return mockApiCall(successMessage, result);
}

export function mockRejectApiCall(errorResult) {
    return mockApiCall(errorResult);
}